import axios, { CancelTokenSource } from 'axios'
import React, { useEffect, useState } from 'react'
import { Error, getErrorMessageByKey, newUuid } from '../functions'
import { useNotification } from './useNotification'

interface IUseObjectProps {
  object: [object, React.Dispatch<React.SetStateAction<object>>]
  update: [boolean, React.Dispatch<React.SetStateAction<string | boolean>>, () => void]
  url: [string, React.Dispatch<React.SetStateAction<string>>]
  params: [string, React.Dispatch<React.SetStateAction<object>>]
  apiUrl: string
  apiUrlParams: string
  setApiUrl: React.Dispatch<React.SetStateAction<string>>
  setApiUrlParams: React.Dispatch<React.SetStateAction<object>>
}
type UseObjectProps = IUseObjectProps

export const useObject = (props: {
  apiUrl?: string
  rootUrl?: string
  urlParams?: object | null
  callbackResponse?: (response: object) => void
  callbackError?: (error: Error) => void
}): UseObjectProps => {
  const [object, setObject] = useState<object>(null)
  const [isUpdateObject, setIsUpdateObject] = useState<string | boolean>(false)
  const [isRequest, setIsRequest] = useState(false)
  const [cancelTokenSource, setCancelTokenSource] = useState<CancelTokenSource | undefined>(undefined)

  const [apiUrl, setApiUrl] = useState(props.apiUrl)
  const [apiUrlParams, setApiUrlParams] = useState(props.urlParams)

  const { notification } = useNotification()

  useEffect(() => {
    return () => {
      setObject(null)
      setApiUrlParams(null)
      setIsRequest(false)
      if (cancelTokenSource) {
        cancelTokenSource.cancel()
      }
    }
  }, [])

  const escapeRegExp = (string: string): string => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
  }

  const replaceAll = (str: string, find: string, replace: string): string => {
    return str.replace(new RegExp(escapeRegExp(find), 'g'), replace)
  }

  const getApiUrlParams = (): string => {
    const params: Record<string, string> = {
      ...((!!apiUrlParams && apiUrlParams) || {})
    } as Record<string, string>

    return replaceAll(new URLSearchParams(params).toString(), '%2C', ',')
  }

  const getApiUrl = (): string => {
    return apiUrl + (getApiUrlParams().length > 0 ? '?' + getApiUrlParams() : '')
  }

  useEffect(() => {
    // TODO Доработать механизм залипания запроса.
    // console.log('object: ' + isUpdateObject.toString())
    if (isRequest) {
      return
    }
    setIsRequest(true)

    const source = axios.CancelToken.source()
    setCancelTokenSource(source)

    void axios
      .get(
        getApiUrl(),
        {
          withCredentials: false,
          cancelToken: source.token,
          baseURL: props.rootUrl,
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('tokenSession')
          }
        }
      )
      .then((response) => {
        setIsRequest(false)
        setCancelTokenSource(null)
        if (props.callbackResponse) {
          props.callbackResponse(((!!response && !!response.data && response.data) || null) as (object))
        }
        const object = ((!!response && !!response.data && response.data) || null) as (object)
        setObject(object)
      })
      .catch((error: Error) => {
        setIsRequest(false)
        setCancelTokenSource(null)
        // const errorTag = (
        //   (!!error &&
        //     !!error.response &&
        //     !!error.response.data &&
        //     !!error.response.data.error &&
        //     (error.response.data.error)
        //   ) || '')
        // notification(getErrorMessageByKey(errorTag), 'red')
        if (props.callbackError) {
          props.callbackError(error)
        }
      })
  }, [isUpdateObject, apiUrl, apiUrlParams])

  const changeUpdateObject = (): void => {
    const uuid = newUuid()
    // console.log('action: ' + uuid)
    setIsUpdateObject(uuid)
  }

  return {
    object: [(!!object && object) || null, setObject] as
      [object, React.Dispatch<React.SetStateAction<object>>],
    update: [isUpdateObject as boolean, setIsUpdateObject, changeUpdateObject],
    url: [apiUrl, setApiUrl],
    params: [getApiUrlParams(), setApiUrlParams],
    apiUrl,
    apiUrlParams: getApiUrlParams(),
    setApiUrl,
    setApiUrlParams
  }
}
